<div>
  <h4 translate>SEPA_DIRECT_DEBIT</h4>
</div>
<hr />
<div>
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-baseline">
        <div>
          <h5 class="mb-0 mt-0" translate>CREDITOR_INFORMATION</h5>
          <span class="font-italic small mb-2 d-inline-block" translate>CREDITOR_INFORMATION_DESCRIPTION</span>
        </div>
  
        <button class="btn btn-default" style="font-size: 20px;" (click)="save()">
          <i ngbTooltip="{{'SAVE' | translate}}" class="fas fa-save"></i>
        </button>
      </div>
    </div>
  </div>

  @if (loaded) {
    <div class="row mt-2" [formGroup]="form">
      <div class="col-12 col-md-3">
        <lib-gung-text-input gungTranslate="COMPANY_NAME" formControlName="name"></lib-gung-text-input>
      </div>
  
      <div class="col-12 col-md-3">
        <lib-gung-text-input gungTranslate="CREDITOR_ID" formControlName="creditorId"></lib-gung-text-input>
      </div>

      <div class="col-12 col-md-3">
        <lib-gung-text-input gungTranslate="IBAN" formControlName="iban"></lib-gung-text-input>
      </div>

      <div class="col-12 col-md-3">
        <lib-gung-text-input gungTranslate="BIC" formControlName="bic"></lib-gung-text-input>
      </div>

      <div class="col-12 col-md-3">
        <lib-gung-text-input gungTranslate="SEPA_AGREEMENT_NUMBER" formControlName="sepaAgreementNumber"></lib-gung-text-input>
      </div>
    </div>
  }

  <lib-sepa-mandates-list/>

  <hr class="mt-4" />
  <lib-sepa-safeguard-config/>
  <lib-sepa-safeguard-override/>
  <lib-sepa-safeguard-history/>
</div>